import { getAllActiveSections } from "../../views/landing/primitive/DotsNavigationPrimitive"

export default function dots_navigation(): any[] { 
    return [ 
        { 
            "width": 25,
            "height": 12,
            "activeHeight": 12,
            "activeWidth": 45,
            "gap": 12,
            "borderWidth": 0,
            "activeColor": "var(--force-contast-color)",
            "align": "end",
            "tooltip": 1,
            "distance": 20,
            design_type: 0,
            "items": getAllActiveSections(),
            defaultTitle: "Навигация компактная перфорация"
        },
        { 
            "width": 15,
            "height": 15,
            "activeHeight": 40,
            "gap": 12,
            "borderWidth": 0,
            "activeColor": "var(--force-contast-color)",
            "align": "end",
            "tooltip": 1,
            "distance": 20,
            design_type: 1,
            "items": getAllActiveSections(),
            defaultTitle: "Навигация, свободная перфорация"
        },
        { 
            "width": 25,
            "height": 25, 
            "gap": 12,
            "borderWidth": 1,
            borderColor: "var(--force-plain-color)",
            "activeColor": "var(--force-contast-color)",
            activeBorderColor: "var(--red)", 
            "align": "end",
            "tooltip": 1,
            "distance": 20,
            design_type: 2,
            "items": getAllActiveSections(),
            defaultTitle: "Компактные квадратики"
        },
        { 
            "width": 25,
            "height": 25, 
            "gap": 12,
            "borderWidth": 1, 
            borderColor: "var(--force-plain-color)",
            "activeColor": "var(--force-contast-color)",
            activeBorderColor: "var(--red)",
            "align": "end",
            "tooltip": 1,
            "distance": 20,
            design_type: 3,
            "items": getAllActiveSections(),
            defaultTitle: "Большие квадраты"
        },
        { 
            "width": 40,
            "height": 40, 
            "gap": 12,
            "borderWidth": 1,
            borderColor: "var(--force-plain-color)",
            "activeColor": "var(--force-contast-color)",
            activeBorderColor: "var(--red)", 
            borderRound: 20,
            "align": "middle",
            "tooltip": 1,
            "distance": 20,
            design_type: 4,
            "items": getAllActiveSections(),
            defaultTitle: "Большие круглые кнопки"
        },
        { 
            "width": 20,
            "height": 20, 
            "gap": 12,
            "borderWidth": 4, 
            borderColor: "var(--force-plain-color)",
            "activeColor": "var(--force-contast-color)",
            activeBorderColor: "var(--red)",
            borderRound: 10,
            "align": "middle",
            "tooltip": 1,
            "distance": 20,
            design_type: 5,
            "items": getAllActiveSections(),
            defaultTitle: "Компактные круглые кнопки"
        },
        { 
            "width": 25,
            "height": 12,
            "activeHeight": 12,
            "activeWidth": 45,
            "gap": 12,
            "borderWidth": 0,
            borderRound: 6,
            "activeColor": "var(--force-contast-color)",
            "align": "end",
            "tooltip": 1,
            "distance": 20,
            design_type: 0,
            "items": getAllActiveSections(),
            defaultTitle: "Навигация, капсюли"
        },
    ]
}